import { CircularProgress } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'

const LoadingPage = () => {
  const {isLoading, message} = useSelector(state => state.loader);

  console.log({isLoading})

  if(isLoading)
  return (
    <div style={{
      position : 'fixed',
      top : 0,
      left: 0,
      width: '100vw',
      height :'100vh',
      display : 'grid',
      placeContent : 'center',
      justifyItems : 'center',
      color : 'white',
      backgroundColor : 'rgba(0,0,0,0.8)',
      zIndex: 9999
    }} >
      <CircularProgress color='white' />
      {message && <p>{message}</p>}
    </div>
  )
}

export default LoadingPage